import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let AmFeBreadCrumb = class AmFeBreadCrumb extends Vue {
  constructor() {
    super(...arguments);
    this.key = new Date().getTime();
  }
  get separatorIcon() {
    return this.separatorClass ? 'yxt-icon-' + this.separatorClass : '';
  }
  separatorChange() {
    if (this.separatorIcon) return;
    this.updateKey();
  }
  separatorIconChange() {
    this.updateKey();
  }
  updateKey() {
    this.key = new Date().getTime();
  }
  navigateTo(path) {
    if (this.navigateToSetter) {
      this.navigateToSetter(path);
      return;
    }
    if (!path.to) return;
    const hash = window.location.hash;
    const isCompile = hash.startsWith('#/page_');
    const pid = String(path.to).includes('/') ? String(path.to).split('/')[1] : '';
    let target = '_blank';
    let href = '';
    // 是否编译
    if (isCompile) {
      if (!pid) return;
      href = window.location.href.replace(hash, `#/page_${pid}`);
      target = '_self';
    } else {
      target = hash.startsWith('#/editor') ? '_blank' : '_self';
      href = `${window.location.origin}/#/preview/${path.to}`;
    }
    window.open(href, target, path.replace);
  }
};
AmFeBreadCrumb.componentName = 'AmFeBreadCrumb';
__decorate([Prop()], AmFeBreadCrumb.prototype, "options", void 0);
__decorate([Prop()], AmFeBreadCrumb.prototype, "separator", void 0);
__decorate([Prop()], AmFeBreadCrumb.prototype, "separatorClass", void 0);
__decorate([Prop({
  default: 'common'
})], AmFeBreadCrumb.prototype, "theme", void 0);
__decorate([Prop(Function)], AmFeBreadCrumb.prototype, "navigateToSetter", void 0);
__decorate([Watch('separator')], AmFeBreadCrumb.prototype, "separatorChange", null);
__decorate([Watch('separatorIcon')], AmFeBreadCrumb.prototype, "separatorIconChange", null);
AmFeBreadCrumb = __decorate([Component({
  name: 'AmFeBreadCrumb'
})], AmFeBreadCrumb);
export default AmFeBreadCrumb;